<template>
  <ChartContainer :params.sync="params">
    <v-tabs active-class="tab-active" height="75px" hide-slider>
      <v-tab class="d-flex" @click="setDataByKey('user')">
        <div class="flex-grow-0 pr-4">
          <v-icon>
            mdi-account-box
          </v-icon>
        </div>
        <div class="flex-grow-1">
          <div class="d-flex flex-column">
            <div class="">
              Người dùng ({{ $n(dashboard.user.total_current || 0) }})
            </div>
            <GrowthPercentText
              :before="dashboard.user.total_before"
              :current="dashboard.user.total_current"
            />
          </div>
        </div>
      </v-tab>
      <v-tab class="d-flex" @click="setDataByKey('session')">
        <div class="flex-grow-0 pr-4">
          <v-icon>
            mdi-account-box
          </v-icon>
        </div>
        <div class="flex-grow-1">
          <div class="d-flex flex-column">
            <div class="">
              Session ({{ $n(dashboard.session.total_current || 0) }})
            </div>
            <GrowthPercentText
              :before="dashboard.session.total_before"
              :current="dashboard.session.total_current"
            />
          </div>
        </div>
      </v-tab>
    </v-tabs>
    <v-responsive :aspect-ratio="16 / 9">
      <v-card-text class="full-width full-height">
        <ChartLoadingContainer :loading="loading">
          <ChartJSComponent
            :key="keyRender"
            class="full-width full-height"
            :datasets="datasets"
            :labels="labels"
            :options="options"
            :type="chartType"
          />
        </ChartLoadingContainer>
      </v-card-text>
    </v-responsive>
  </ChartContainer>
</template>

<script>
import ChartJSComponent from '@components/chart/ChartJSComponent.vue'
import ChartContainer from '../ChartContainer.vue'
import ChartLoadingContainer from '@components/chart/ChartLoadingContainer.vue'
import sdk from '@service/auth-sdk'
import GrowthPercentText from '../GrowthPercentText.vue'
import { debounce, getChartColor } from '@utils'
export default {
  components: {
    ChartJSComponent,
    ChartLoadingContainer,
    ChartContainer,
    GrowthPercentText,
  },
  props: {},
  data: (vm) => ({
    params: { type: '7days' },
    loading: false,
    keyRender: 0,
    chartType: 'line',
    labels: [],
    dashboard: { user: {}, session: {} },
    datasets: [
      {
        label: 'Lần truy cập',
        data: [],
        lineTension: 0,
        fill: false,
        borderColor: getChartColor(0),
        backgroundColor: getChartColor(0),
      },
    ],
    options: {
      tooltips: {
        mode: 'nearest',
        callbacks: {
          title: function(tooltipItem) {
            let corporation = new Date(tooltipItem[0].xLabel)
            return `${corporation
              .getDate()
              .toString()
              .padStart(2, '0')}/${(corporation.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${corporation.getFullYear()}`
          },
          label: function(tooltipItem, data) {
            let corporation = data.datasets[tooltipItem.datasetIndex].label
            return `${corporation}: ${vm.$n(tooltipItem.value)}`
          },
        },
      },
      title: {
        display: false,
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            ticks: {
              callback: function(value, index, values) {
                if (index == 0)
                  return `${value.getDate()}/Th.${value.getMonth() + 1}`
                else if (value.getMonth() != values[index - 1].getMonth())
                  return `${value.getDate()}/Th.${value.getMonth() + 1}`
                return `${value.getDate()}`
              },
            },
          },
        ],
        yAxes: [
          {
            stacked: false,
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        ],
      },
    },
  }),
  computed: {},
  watch: {
    params: {
      handler: debounce(function() {
        this.fetchData()
      }, 100),
      deep: true,
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    getGrowthPercent(data = {}) {
      if (data.total_current > 0 || data.total_before > 0) {
        return round(
          ((data.total_current - data.total_before) /
            (data.total_before || 1)) *
            100
        )
      }
      return 0
    },
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/user/frequency-view',
        params: this.params,
      })
      this.dashboard = res.data
      this.loading = false
      this.setDataByKey('user')
    },
    setDataByKey(key) {
      this.keyRender++
      this.datasets[0].data = []
      this.labels = []
      let data = this.dashboard[key].data
      for (let i in data) {
        let item = data[i]
        this.datasets[0].data.push(item.count)
        this.labels.push(new Date(item.date))
      }
    },
  },
}
function round(num) {
  var m = Number((Math.abs(num) * 100).toPrecision(15))
  return (Math.round(m) / 100) * Math.sign(num)
}
</script>

<style scoped></style>
